module.exports = __webpack_public_path__ + "img/A-Microalgae.e83ae153.png";